import React, { Component } from 'react';
import Text from 'components/Text';
import QuestionnaireParent from 'components/QuestionnaireParent';
import v from 'vudu';
import { classes as c, colors } from 'stylesheet';
import copy from 'constants/copy';

const localClasses = v({
  questionnaireView: {
    height: '100%',
    padding: '0 20px',
  },
  panelsHero: {
    maxWidth: '500px',
    textAlign: 'center',
    margin: '140px auto 40px auto',
    borderBottom: '1px solid rgba(148, 138, 148, 0.2)'
  },
  panelsBody: {
    maxWidth: '500px',
    textAlign: 'center',
    margin: 'auto',
  }
});

export default class QuestionnaireView extends Component {
  state = {}
  render() {
    return (
      <section className={localClasses.questionnaireView}>
        <div className={localClasses.panelsHero}>
          <Text variant={'headline'} color={'white'}>{copy.questionnaireView.heading}</Text>
          <Text variant={'subheadline'} color={'taupe'} classes={c.pb3}>{copy.questionnaireView.subheading}</Text>
        </div>

        <div className={localClasses.panelsBody}>
          <QuestionnaireParent results={this.props.results} questions={this.props.questions} setResult={this.props.setResult} />
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/QuestionnaireView.js